import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import { TravellerFeedbackProvider, useTravellerFeedback } from '../../context/travellerFeedback/TravellerFeedbackContext';
import FeedbackHeader from './sections/Header/FeedbackHeader';
import StatsCards from './sections/StatsCards/StatsCards';
import FeedbackList from './sections/FeedbackList/FeedbackList';
import FeedbackModal from './sections/FeedbackList/sections/FeedbackModal/FeedbackModal';
import FeedbackSkeleton from './sections/FeedbackSkeleton/FeedbackSkeleton';

const FeedbackContent = () => {
  const { isLoading } = useTravellerFeedback();

  return (
    <div className="space-y-6">
      <FeedbackHeader />
      {isLoading ? (
        <FeedbackSkeleton />
      ) : (
        <>
          <StatsCards />
          <FeedbackList />
        </>
      )}
      <FeedbackModal />
    </div>
  );
};

const TravellerFeedbackPage = () => {
  return (
    <TravellerFeedbackProvider>
      <MainLayout activeTab="feedback">
        <PageContainer>
          <FeedbackContent />
        </PageContainer>
      </MainLayout>
    </TravellerFeedbackProvider>
  );
};

export default TravellerFeedbackPage;
